import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import AuthService from './AuthService'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import DynamicForm, { IDynamicForm, IRequiredField } from '../../components/Form/DynamicForm'
import { addNewForm, createOrUpdateElementData, updateFormLoading } from '../../components/Form/formsSlice'
import GenerateForm from '../../components/Form/GenerateForm'
import { LoadingButton, Skeleton } from '@mui/lab'
import ApplicationLogo from '../../components/ApplicationLogo'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'

interface IProps {
    profilePage?: boolean
}

export default function Register2FA(props: IProps) {

    const dispatch = useDispatch()

    const { profilePage } = props

    const [qrCode, setQrCode] = useState<string>("")
    const [hash, setHash] = useState<string>("")

    const [loading, setLoading] = useState<boolean>(true)
    const [formLoading, setFormLoading] = useState<boolean>(false)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)

    const user = useSelector((state: RootState) => state.user.details)

    const elemPrefix: string = "enable-two-factor_"
    const form: IDynamicForm = {
        name: "enable-two-factor",
        elements: [
            {
                id: elemPrefix + "otp",
                xs: 12,
                type: "TextField",
                label: "OTP",
                fullWidth: true,
                fieldType: "number"
            },
        ]
    }

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(elemPrefix + name, elementsData).value

    /**
     * Update loading
     */
    const updateLoading = (status: boolean) => {
        dispatch(updateFormLoading({ formName: form.name, loading: status }))
        setFormLoading(status)
    }

    /**
     * Create form elem data
     */
    const createFormElemData = () => {
        form.elements.map((elem) => dispatch(createOrUpdateElementData({
            name: elem.id,
            value: ""
        })))
    }

    /**
     * Enable 2FA
     */
    const enable = () => {
        setLoading(true)
        AuthService.enable2FA()
            .then(response => {

                const { message, topt_uri, topt_qrcode } = response.data

                setQrCode(topt_qrcode)
                setLoading(false)
                setHash(topt_uri)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })
    }

    /**
     * Handle submit
     */
    const handleSubmit = () => {

        const otp = singleElemDataValue("otp")


        let requiredFields: IRequiredField[] = [
            {
                id: elemPrefix + "otp",
                message: "OTP is required"
            },
        ]

        DynamicForm.resetRequiredFieldsHelperText(requiredFields, elementsData, dispatch)
        const verifyForm = DynamicForm.verifyForm(elementsData, requiredFields)

        if (verifyForm.isValid){
            AuthService.verify2FA(otp)
                .then(response => {

                    const { data } = response

                    const message = data.message ? data.message : "Success!"
                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "success", message: message }, dispatch)


                    updateQuickNotificationDetails(true, message, "success", dispatch)

                    setTimeout(() => window.location.reload(), 1500)

                    setIsSuccess(true)

                })
                .catch(error => {

                    console.log(error)
                    const message = error.response.data.message ? error.response.data.message : "Fatal Error"

                    setIsSuccess(false)
                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "error", message: message }, dispatch)

                })
        }else{
            DynamicForm.updateRequiredFieldsHelperText(verifyForm.fields, elementsData, dispatch)
        }

    }

    useEffect(() => {
        enable()
    }, [])

    useEffect(() => {
        dispatch(addNewForm(form))
        createFormElemData()
    }, [])

    return(
                <div className="login-form-box-container">
                    <div className="content-of-login-form-box-container">

                        <div className="logo-box-of-login-form-box-container">
                            <div className="content-of-logo-box-of-login-form-box-container">
                                <ApplicationLogo />
                            </div>
                        </div>

                        <div className="text-box-of-login-form-box-container">
                            <div className="content-of-text-box-of-login-form-box-container">
                                <h2>Two-Factor Authentication</h2>
                                <p>
                                    To enable Two-Factor Authentication, you need to scan the QR Code below with your Google Authenticator App, and enter the OTP verification code down below.
                                </p>
                            </div>
                        </div>

                        <div className="img-of-login-form-box-container">
                            <div className="content-of-img-of-login-form-box-container">
                                {loading ? <Skeleton variant="rectangular" width={150} height={150} /> : <img src={qrCode} />}
                            </div>
                        </div>

                        <div className="form-of-login-form-box-container">
                            <div className="content-of-form-of-login-form-box-container">
                                <GenerateForm name={form.name} />

                                <div className="submit-button-box-of-login-form">
                                    <LoadingButton disabled={isSuccess} onClick={() => handleSubmit()} className="general-button" loading={formLoading} variant="contained" fullWidth type="submit">Register</LoadingButton>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
    )
}